var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "#ff681e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,17.2c-37.84,0 -68.8,30.96 -68.8,68.8c0,37.84 30.96,68.8 68.8,68.8c37.84,0 68.8,-30.96 68.8,-68.8c0,-12.61333 -3.43776,-24.08 -9.17109,-34.4l-64.79115,64.79114c-1.14667,1.14667 -2.28885,1.71328 -4.00885,1.71328c-1.72,0 -2.87339,-0.56661 -4.02005,-1.71328l-25.8,-25.8c-2.29333,-2.29333 -2.29333,-5.73557 0,-8.0289c2.29333,-2.29333 5.73557,-2.29333 8.02891,0l21.79115,21.77995l61.91328,-62.48438c-12.61333,-14.90667 -31.52886,-24.65781 -52.74219,-24.65781zM138.74219,41.85781c2.86667,2.86667 5.16672,6.30219 6.88672,9.74219l13.17995,-13.19115c2.29333,-2.29333 2.29333,-5.73333 0,-8.6c-2.29333,-2.29333 -5.72438,-2.29333 -8.01771,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0a39e230e4ea017d59fbba6b4a321b76.svg";
export { ForwardRef as ReactComponent };